import { Icon, SectionHeader } from "../../components/public/ui";

const categories = [
  {
    icon: "headphones",
    iconBox:
      "w-12 h-12 rounded-xl bg-primary-fixed flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-on-primary transition-colors",
    chip: "px-2.5 py-0.5 rounded-full bg-primary-fixed/40 text-primary font-label-sm text-[11px] font-semibold",
    chipLabel: "30+ Mock Audios",
    title: "Listening Practice",
    body: "Improve your auditory recall with realistic multi-speaker dialogues, workplace situations, and news announcements.",
    link: "text-primary",
  },
  {
    icon: "auto_stories",
    iconBox:
      "w-12 h-12 rounded-xl bg-secondary-fixed flex items-center justify-center text-secondary group-hover:bg-secondary group-hover:text-on-secondary transition-colors",
    chip: "px-2.5 py-0.5 rounded-full bg-secondary-fixed/40 text-secondary font-label-sm text-[11px] font-semibold",
    chipLabel: "45+ Exam Passages",
    title: "Reading Practice",
    body: "Strengthen reading agility across correspondence, diagrams, informative texts, and viewpoint synthesis.",
    link: "text-secondary",
  },
  {
    icon: "edit_note",
    iconBox:
      "w-12 h-12 rounded-xl bg-tertiary-fixed flex items-center justify-center text-tertiary group-hover:bg-tertiary group-hover:text-on-tertiary transition-colors",
    chip: "px-2.5 py-0.5 rounded-full bg-tertiary-fixed/40 text-tertiary-container font-label-sm text-[11px] font-semibold",
    chipLabel: "Instant Rubric Scoring",
    title: "Writing Practice",
    body: "Develop high-scoring email correspondences and detailed survey responses with instant AI coherence checks.",
    link: "text-tertiary",
  },
  {
    icon: "mic",
    iconBox:
      "w-12 h-12 rounded-xl bg-primary-fixed-dim flex items-center justify-center text-primary group-hover:bg-primary-container group-hover:text-on-primary transition-colors",
    chip: "px-2.5 py-0.5 rounded-full bg-primary-fixed/50 text-primary font-label-sm text-[11px] font-semibold",
    chipLabel: "AI Speech Feedback",
    title: "Speaking Practice",
    body: "Tackle all 8 speaking tasks with authentic preparation countdowns, microphone recording, and pronunciation drills.",
    link: "text-primary",
  },
];

export const Categories = () => (
  <section className="w-full py-20 bg-surface scroll-mt-20" id="categories">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <SectionHeader
        eyebrow="Comprehensive Curriculum"
        title="Everything You Need to Prepare with Confidence"
        description="Master each required CELPIP discipline with authentic timings, dynamic test prompts, and instant diagnostic feedback."
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {categories.map((c) => (
          <div
            key={c.title}
            className="group relative bg-surface-container-lowest rounded-2xl p-7 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col justify-between hover:-translate-y-1"
          >
            <div className="flex flex-col gap-4">
              <div className={c.iconBox}>
                <Icon name={c.icon} className="text-2xl" />
              </div>
              <div className="flex items-center gap-2">
                <span className={c.chip}>{c.chipLabel}</span>
              </div>
              <h3 className="font-headline-sm text-headline-sm text-on-surface">
                {c.title}
              </h3>
              <p className="font-body-sm text-body-sm text-on-surface-variant leading-relaxed">
                {c.body}
              </p>
            </div>
            <div className="pt-6">
              <a
                className={`inline-flex items-center gap-2 font-label-md text-label-md font-bold group-hover:gap-3 transition-all ${c.link}`}
                href="#practice-preview"
              >
                <span>Start Practicing</span>
                <Icon name="arrow_forward" className="text-base" />
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
